"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Boolean = void 0;
const models_1 = require("lincd/lib/models");
const Shape_1 = require("lincd/lib/shapes/Shape");
const xsd_1 = require("../ontologies/xsd");
const package_1 = require("../package");
let Boolean = class Boolean extends Shape_1.Shape {
    static true() {
        return new models_1.Literal('true', this.targetClass);
    }
    static false() {
        return new models_1.Literal('false', this.targetClass);
    }
    static toLiteral(value) {
        return value ? this.true() : this.false();
    }
    static isTrue(literalNode) {
        return (literalNode === null || literalNode === void 0 ? void 0 : literalNode.value) == 'true';
    }
    static isFalse(literalNode) {
        return (literalNode === null || literalNode === void 0 ? void 0 : literalNode.value) == 'false';
    }
    /**
     * Updates a boolean value of the given node with the opposite of its current boolean value.
     * Will be set to true if not set yet.
     * @param resource
     * @param property
     */
    static negate(resource, property) {
        let currentlyTrue = resource.hasProperty(property)
            ? this.isTrue(resource.getOne(property))
            : false;
        resource.overwrite(property, currentlyTrue ? this.false() : this.true());
    }
};
exports.Boolean = Boolean;
Boolean.targetClass = xsd_1.xsd.boolean;
exports.Boolean = Boolean = __decorate([
    package_1.linkedShape
], Boolean);
//# sourceMappingURL=Boolean.js.map